import React, { useCallback, useEffect, useState } from 'react';
import SelectDropdown from 'components/base/select-dropdown';
import { IngredientListType } from 'models/pricing.model';
import { apiService } from 'services/base.service';
import { debounce, handleApiError } from 'utils/functions';

type Props = {
  index: number;
  ingredient_name: string;
  handleChange: (e: { name: string; value: string; rest?: any }, index: number) => void;
};
const MixSelect = ({ index, handleChange, ingredient_name }: Props) => {
  const [search, setSearch] = useState('');
  const [ingredients, setIngredients] = useState<IngredientListType[]>([]);

  const fetchIngredients = async (searchString: string) => {
    try {
      const response = await apiService.get(`ingredient-mix`, {
        version: 'v2',
        params: {
          name: searchString,
          page: 1,
          type: 'prep'
        }
      });
      if (response) {
        setIngredients(
          response.data.data.map((item: any) => {
            return { ...item, name: item.ingredient.name };
          })
        );
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      // setSearch('');
    }
  };

  const debounceFetchIngredients = useCallback(debounce(fetchIngredients, 500), []);

  useEffect(() => {
    debounceFetchIngredients(search);
  }, [search]);
  return (
    <SelectDropdown
      hasSearch
      placeholder='Search mix'
      label='Prep Mixes'
      value={ingredient_name}
      setValue={(item) => {
        handleChange(
          {
            name: 'ingredient_id',
            value: item?.ingredient?.id,
            rest: item
          },
          index
        );
      }}
      onChange={(val) => {
        setSearch(val);
      }}
      options={ingredients}
    />
  );
};
export default MixSelect;
